<template>
  <custom-select
    @apply="applyFilter"
    @close="localClear"
    is-value-selected
    :placeholder="placeholder"
  >
    <template #head>
      <custom-select-tag-head
        v-if="showTag"
        :title="tagTitle"
        @clear="clear"
      />
    </template>

    <custom-select-price-dropdown-content
      @update-price="updatePrice"
      slot="dropdown-content"
      :from="from"
      :to="to"
      :min="minMax.min.toString()"
      :max="minMax.max.toString()"
    />
  </custom-select>
</template>

<script>
import CustomSelect from '@kit/custom-select/custom-select.vue';
import CustomSelectTagHead from '@kit/custom-select/custom-select-tag-head.vue';
import CustomSelectPriceDropdownContent from '@kit/custom-select/custom-select-price-dropdown-content.vue';

import priceFilterMixin from '@/components/filters/price-filter-mixin';

export default {
  components: {
    CustomSelect,
    CustomSelectTagHead,
    CustomSelectPriceDropdownContent,
  },

  mixins: [priceFilterMixin],

  props: {
    placeholder: {
      type: String,
      required: true,
    },
  },

  computed: {
    tagTitle() {
      return `Цена: ${this.from} - ${this.to}`;
    },
    showTag() {
      return this.value.length > 0;
    }
  },
}
</script>